import { $http } from '@/utils';

/**
 * @namespace Service
 * @class UserAccount
 * @exports Service/Account/UserAccount
 * @description API User Account Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class UserAccount {
	/**
	 * @static @name modify
	 * @description Update some User account for ID
	 * @param {String} id
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static patch(id, payload) {
		return $http.patch(`account/user/account/${id}`, payload);
	}
}
